// @flow

import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import Link from 'app/common/components/Link';
import LoginActions from 'app/login/LoginActions';
import LoginForm from 'app/login/components/LoginForm';
import { addTruthyParamsToUrl } from 'app/common/utils/UrlUtils';
import { getQueryParams } from 'app/common/utils/RouterSelectors';
import { isReset } from 'app/login/submitResults';
import { isValidEmail } from 'app/common/CommonUtils';
import { parseUsernameAndCode } from 'app/login/LoginUtils';

const Description = ({ username }: { username: string }) => {
  if (isValidEmail(username)) {
    return <p>Set the password for {username}.</p>;
  }

  return <p>Set your password.</p>;
};

const PasswordChanged = (props: { query: {}, email: string }) => {
  const url = addTruthyParamsToUrl('/app/login/', {
    ...(props.query || {}),
    email: props.email,
  });

  return (
    <span>
      Password changed! Click{' '}
      <Link href={url} shouldRefreshPage={true}>
        here
      </Link>{' '}
      to continue.
    </span>
  );
};

const mapStateToProps = state => {
  const [username, code] = parseUsernameAndCode(
    state.router.current.location.hash
  );
  const page = state.login.resetPage;

  // can't submit while data in flight, and both password fields are required
  const canSubmit =
    !page.isSubmitting && !!page.form.password1 && !!page.form.password2;

  const didSucceed = isReset(page.result.resultType);
  const message = didSucceed ? (
    <PasswordChanged email={username} query={getQueryParams(state)} />
  ) : (
    (page.result.errors || []).join(' ')
  );
  const messageType = didSucceed ? 'success' : 'error';

  return {
    username,
    code,
    title: 'Set Password',
    submitText: 'Set New Password',
    canSubmit,
    didSucceed,
    isSubmitting: page.isSubmitting,
    fields: [
      {
        name: 'password1',
        type: 'password',
        placeholder: 'Password',
        autoFocus: true,
        value: page.form.password1,
      },
      {
        name: 'password2',
        type: 'password',
        placeholder: 'Confirm Password',
        value: page.form.password2,
      },
    ],
    message,
    messageType,
    description: <Description username={username} />,
    shouldShowLoginForm: true,
  };
};

const mapDispatchToProps = (dispatch: Dispatch, state) => {
  return {
    onChange: (value, name) => {
      dispatch(LoginActions.updateForm('resetPage', name, value));
    },
    onSubmit: fields => {
      const [username, code] = parseUsernameAndCode(
        state.router.current.location.hash
      );
      const password1 = _.find(fields, { name: 'password1' });
      const password2 = _.find(fields, { name: 'password2' });
      const next = state.query.next;
      dispatch(
        LoginActions.resetPassword(
          username,
          code,
          password1.value,
          password2.value,
          next
        )
      );
    },
  };
};

const ResetFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);

export default ResetFormContainer;
